var _rect, _rect2, _g, _g2, _path, _path2, _path3, _path4, _g3, _g4, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightFacingfist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.5625,
    height: 7.10863,
    transform: "matrix(-1 0 0 1 24.1641 15.7881)",
    fill: "url(#paint0_radial_715_19353)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9.5625,
    height: 7.10863,
    transform: "matrix(-1 0 0 1 24.1641 15.7881)",
    fill: "url(#paint1_radial_715_19353)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_715_19353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.308 18.721C22.4365 17.9723 22.3248 17.2141 22.2422 16.8975H25.0391V24.1943H18.3359C17.2578 24.1943 16.4375 22.585 16.7031 21.3506C16.9688 20.1162 18.1349 19.0737 19.4141 19.1475C20.3769 19.203 21.3068 19.1641 21.9382 19.0743C22.1255 19.0477 22.276 18.9075 22.308 18.721Z",
    fill: "url(#paint2_radial_715_19353)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_715_19353)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4453 7.95996C27.4829 7.95996 29.9453 10.4224 29.9453 13.46V19.085L29.9414 19.0854V19.4834C29.9518 20.2074 29.7359 22.0631 28.8984 23.2881C27.8515 24.8193 26.0391 26.0381 24.2578 26.0381H22.1541C22.2294 26.3188 22.2559 26.6109 22.2876 26.9591L22.2891 26.9756C22.2891 27.999 21.8516 29.5381 19.6484 29.9756C18.6641 30.124 17.6484 29.7021 16.8203 29.0459C16.3484 28.6719 15.5273 27.9745 14.8587 27.4065C14.5887 27.1771 14.3435 26.9688 14.1562 26.8115C14.1157 26.7775 14.0727 26.7403 14.0273 26.7011C13.6698 26.392 13.1647 25.9554 12.5547 25.9131C11.7201 25.8552 10.1346 25.5338 8.20312 23.6943C7.42328 22.9516 6.80252 21.9461 6.4483 21.3723C6.35541 21.2218 6.28085 21.101 6.22656 21.0225C6.173 20.945 6.12881 20.8744 6.08875 20.8105C5.85422 20.4363 5.76138 20.2881 4.75781 20.2881L4.76541 20.2803H4.05469C2.95013 20.2803 2.05469 19.3848 2.05469 18.2803V9.95996C2.05469 8.85539 2.95013 7.95996 4.05469 7.95996H24.4453ZM17.1431 20.2591C16.8705 19.7857 16.4572 18.9884 16.2734 18.3428C16 17.3818 16.5122 17.272 16.7578 17.2256C17.1283 17.1556 17.7 17.164 18.2939 17.1727C18.4952 17.1757 18.699 17.1787 18.8984 17.1787C19.1348 17.1787 19.3904 17.1812 19.6561 17.1838C20.883 17.1956 22.3226 17.2096 23.0547 16.9912C23.1875 17.0563 23.4531 17.3084 23.4531 17.7959L23.4533 17.8962C23.4549 18.4784 23.4567 19.1037 22.9766 19.4287C22.7988 19.5491 22.4458 19.5756 22.0121 19.6081C21.5253 19.6447 20.937 19.6888 20.3806 19.8818H20.3789C20.3581 19.8893 20.3375 19.8968 20.3171 19.9046C20.0723 19.995 19.8347 20.1156 19.616 20.2785C18.8791 20.804 18.5242 21.552 18.3877 22.0212C17.6865 21.2008 17.2567 20.481 17.1602 20.2686L17.1431 20.2591Z",
    fill: "url(#paint3_radial_715_19353)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4453 7.95996C27.4829 7.95996 29.9453 10.4224 29.9453 13.46V19.085L29.9414 19.0854V19.4834C29.9518 20.2074 29.7359 22.0631 28.8984 23.2881C27.8515 24.8193 26.0391 26.0381 24.2578 26.0381H22.1541C22.2294 26.3188 22.2559 26.6109 22.2876 26.9591L22.2891 26.9756C22.2891 27.999 21.8516 29.5381 19.6484 29.9756C18.6641 30.124 17.6484 29.7021 16.8203 29.0459C16.3484 28.6719 15.5273 27.9745 14.8587 27.4065C14.5887 27.1771 14.3435 26.9688 14.1562 26.8115C14.1157 26.7775 14.0727 26.7403 14.0273 26.7011C13.6698 26.392 13.1647 25.9554 12.5547 25.9131C11.7201 25.8552 10.1346 25.5338 8.20312 23.6943C7.42328 22.9516 6.80252 21.9461 6.4483 21.3723C6.35541 21.2218 6.28085 21.101 6.22656 21.0225C6.173 20.945 6.12881 20.8744 6.08875 20.8105C5.85422 20.4363 5.76138 20.2881 4.75781 20.2881L4.76541 20.2803H4.05469C2.95013 20.2803 2.05469 19.3848 2.05469 18.2803V9.95996C2.05469 8.85539 2.95013 7.95996 4.05469 7.95996H24.4453ZM17.1431 20.2591C16.8705 19.7857 16.4572 18.9884 16.2734 18.3428C16 17.3818 16.5122 17.272 16.7578 17.2256C17.1283 17.1556 17.7 17.164 18.2939 17.1727C18.4952 17.1757 18.699 17.1787 18.8984 17.1787C19.1348 17.1787 19.3904 17.1812 19.6561 17.1838C20.883 17.1956 22.3226 17.2096 23.0547 16.9912C23.1875 17.0563 23.4531 17.3084 23.4531 17.7959L23.4533 17.8962C23.4549 18.4784 23.4567 19.1037 22.9766 19.4287C22.7988 19.5491 22.4458 19.5756 22.0121 19.6081C21.5253 19.6447 20.937 19.6888 20.3806 19.8818H20.3789C20.3581 19.8893 20.3375 19.8968 20.3171 19.9046C20.0723 19.995 19.8347 20.1156 19.616 20.2785C18.8791 20.804 18.5242 21.552 18.3877 22.0212C17.6865 21.2008 17.2567 20.481 17.1602 20.2686L17.1431 20.2591Z",
    fill: "url(#paint4_radial_715_19353)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9453 17.0225V19.085L29.9414 19.0854V19.4834C29.9518 20.2074 29.7359 22.0631 28.8984 23.2881C28.0798 24.4855 26.7931 25.4917 25.4192 25.8737C25.0473 25.9741 24.6693 26.0286 24.2926 26.0286H22.152C22.0703 25.7356 21.8242 25.1418 21.1836 24.5637C21.0683 24.4529 20.8428 24.2648 20.5645 24.0326C19.8719 23.455 18.9219 22.7646 18.3828 22.0264C18.5244 21.556 18.8918 20.795 19.616 20.2785C19.8347 20.1156 20.0723 19.995 20.3171 19.9046C20.3375 19.8968 20.3581 19.8893 20.3789 19.8818H20.3806C20.937 19.6888 21.5253 19.6447 22.0121 19.6081C22.4458 19.5756 22.7988 19.5491 22.9766 19.4287C23.4567 19.1037 23.4549 18.4784 23.4533 17.8962L23.4531 17.7959C23.4531 17.3664 23.2469 17.1196 23.107 17.0225H29.9453Z",
    fill: "url(#paint5_radial_715_19353)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9453 17.0225V19.085L29.9414 19.0854V19.4834C29.9518 20.2074 29.7359 22.0631 28.8984 23.2881C28.0798 24.4855 26.7931 25.4917 25.4192 25.8737C25.0473 25.9741 24.6693 26.0286 24.2926 26.0286H22.152C22.0703 25.7356 21.8242 25.1418 21.1836 24.5637C21.0683 24.4529 20.8428 24.2648 20.5645 24.0326C19.8719 23.455 18.9219 22.7646 18.3828 22.0264C18.5244 21.556 18.8918 20.795 19.616 20.2785C19.8347 20.1156 20.0723 19.995 20.3171 19.9046C20.3375 19.8968 20.3581 19.8893 20.3789 19.8818H20.3806C20.937 19.6888 21.5253 19.6447 22.0121 19.6081C22.4458 19.5756 22.7988 19.5491 22.9766 19.4287C23.4567 19.1037 23.4549 18.4784 23.4533 17.8962L23.4531 17.7959C23.4531 17.3664 23.2469 17.1196 23.107 17.0225H29.9453Z",
    fill: "url(#paint6_linear_715_19353)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9388 17.0225C22.9269 17.0254 22.9148 17.0282 22.9026 17.0311L22.914 17.0225H22.9388Z",
    fill: "url(#paint7_radial_715_19353)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9388 17.0225C22.9269 17.0254 22.9148 17.0282 22.9026 17.0311L22.914 17.0225H22.9388Z",
    fill: "url(#paint8_linear_715_19353)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_715_19353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7207 15.3347C13.6715 17.104 15.4047 23.2024 19.7856 25.947",
    stroke: "url(#paint9_linear_715_19353)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_715_19353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5646 15.285C16.072 15.2146 14.9178 15.3695 14.2422 16.5518C13.5666 17.7341 13.9607 19.0853 14.2422 19.6132",
    stroke: "url(#paint10_linear_715_19353)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_715_19353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6972 12.3821L23.5859 16.3143C24.7207 17.6867 24.1842 19.8771 23.8499 20.7216H27.9669V12.3821H25.6972Z",
    fill: "url(#paint11_linear_715_19353)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_715_19353",
    x: 16.6523,
    y: 16.8975,
    width: 8.48672,
    height: 7.39688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.7875 0 0 0 0 0.278313 0 0 0 0 0.0328125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_19353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_715_19353",
    x: 2.05469,
    y: 7.70996,
    width: 28.6406,
    height: 22.2954,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.75,
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.933333 0 0 0 0 0.486275 0 0 0 0 0.364706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_19353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_715_19353",
    x: 10.2207,
    y: 11.8347,
    width: 13.0645,
    height: 17.6125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25,
    result: "effect1_foregroundBlur_715_19353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_715_19353",
    x: 10.3691,
    y: 11.7717,
    width: 9.69531,
    height: 11.3416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25,
    result: "effect1_foregroundBlur_715_19353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_715_19353",
    x: 21.5859,
    y: 10.3821,
    width: 8.38086,
    height: 12.3396,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_715_19353"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_715_19353",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.78309 4.14972) rotate(-146.915) scale(4.93848 3.87761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D96127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA3A0E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_715_19353",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.14063 1.28125) rotate(90) scale(0.78125 4.67188)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D2602"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2602",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_715_19353",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.0244 20.5459) rotate(17.5931) scale(3.50413 5.74406)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E67E16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF4204"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_715_19353",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.4413 12.4876) rotate(159.592) scale(28.1538 43.4712)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69728"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_715_19353",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.4213 27.6888) rotate(164.932) scale(2.8424 3.59605)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_715_19353",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5974 22.9084) scale(2.15167 3.16327)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00562317,
    stopColor: "#CF6E1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6E1C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_715_19353",
    x1: 22.7686,
    y1: 24.6781,
    x2: 22.7686,
    y2: 26.3195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB755C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB755C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_715_19353",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5974 22.9084) scale(2.15167 3.16327)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00562317,
    stopColor: "#CF6E1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF6E1C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_715_19353",
    x1: 22.7686,
    y1: 24.6781,
    x2: 22.7686,
    y2: 26.3195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB755C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB755C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_715_19353",
    x1: 18.7287,
    y1: 25.6138,
    x2: 19.4424,
    y2: 15.3588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_715_19353",
    x1: 17.1452,
    y1: 14.5461,
    x2: 12.7366,
    y2: 17.7267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_715_19353",
    x1: 23.2165,
    y1: 16.5519,
    x2: 30.3948,
    y2: 18.6104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69D30",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightFacingfist);
export default __webpack_public_path__ + "static/media/Right-facing fist.43f33a9bf8860bf0a041d44d9e27eac7.svg";
export { ForwardRef as ReactComponent };